<button
  mat-stroked-button
  [disabled]="eligibleInvoices.length === 0 || disabled"
  [matMenuTriggerFor]="eligibleInvoices.length > 1 ? invoiceMenu : null"
  (click)="openCharge(eligibleInvoices[0])"
>
  <mat-icon>payment</mat-icon>
  <span>{{ 'payments.charge.collect-payment' | translate }}</span>
</button>

<mat-menu #invoiceMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let inv of eligibleInvoices"
    (click)="openCharge(inv)"
  >
    <mat-icon>receipt_long</mat-icon>
    <span>{{ inv.shortId | shortId }}</span>
  </button>
</mat-menu>
